import { TRootState } from "./store/create-store";

export const selectRootState = (state: TRootState) => state.root;

export const selectLeftPanelState = (state: TRootState) =>
  selectRootState(state).leftPanel;

export const selectRightPanelState = (state: TRootState) =>
  selectRootState(state).rightPanel;

export const selectHasDataset = (state: TRootState) => {
  return Object.values(selectRootState(state).rows).length > 0;
};
